import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from "react-router-dom";
import { Row } from "reactstrap";
import Toast from '../../helpers/Toast';
import { GetProjectsFromClientDTO } from '../../models/Client/GetProjectsFromClientDTO';
import { ProjectDTO } from '../../models/Project/ProjectDTO';
import { ClientService } from '../../services/ClientService';
import TableComponent, { OperationsCell } from "../TableComponent";

function ProjectsFromClient() {
    const { id } = useParams<{ id: string }>();
    const clientService = new ClientService();
    const [projects, setProjects] = useState<ProjectDTO[]>([]);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);

    const columns = React.useMemo(
        () => [
            {
                Header: <FormattedMessage id="Screens.Projects.Table.Column1" />,
                accessor: "description",
                width: 45,
            },
            {
                Header: <FormattedMessage id="Screens.Projects.Table.Column6" />,
                accessor: "notes",
                width: 45,
            },
            {
                Header: "",
                accessor: " ",
                width: 5,
                Cell: (props: any) =>
                    OperationsCell(props.cell.row.original.erpId, "project"),

            },
        ],
        []
    );

    const GetProjects = async (page: number, pageSize: number) => {
        setIsLoading(true);

        const data: GetProjectsFromClientDTO = {
            clientErpId: id!,
            currentPage: currentPage,
            pageSize: pageSize,
        }
        var response = await clientService.GetProjectsFromClient(data);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }

        setProjects(response.items);
        setIsLoading(false);
        setPageCount(response.totalPages);
        setPageSize(pageSize);
        setCurrentPage(page);
        setGoToPage(0)
    }

    useEffect(() => {
        if (id !== '') {
            GetProjects(currentPage ?? 1, pageSize ?? 5)
        }
    }, [id, currentPage, pageSize])
    return (
        <div>
            <Row style={{ margin: "1rem 0px" }}>
                <TableComponent
                    columns={columns}
                    data={projects}
                    goToPage={goToPage}
                    initialPage={currentPage}
                    pageCount={pageCount}
                    initialPageSize={pageSize}
                    pageSizes={pageSizes}
                    manualPagination={true}
                    loading={isLoading}
                    fetchData={GetProjects}
                    initialSortBy={[]}
                    disableSortBy={true}
                    dontOrderFirstCollumn={true}
                />
            </Row>
        </div>

    )
}

export default ProjectsFromClient